import LegalPage from "@/pages/legal/LegalPage";

export default function RefundPolicyPage() {
  return (
    <LegalPage
      title="Refund & Cancellation Policy"
      slug="refund-and-cancellation-policy"
      testIdPrefix="legal-refund"
    />
  );
}
